// extracted by mini-css-extract-plugin
export default {"card":"remote-backup-card-card-yGX4gG","exportButton":"remote-backup-card-exportButton-ArkQz2","importButton":"remote-backup-card-importButton-PdYrXm"};